import { IThemeAssetContributor } from '../ThemeAssetContributor';

export class Theme12ThemeAssetContributor implements IThemeAssetContributor {
    getAssetUrls(): string[] {
        return [''];
    }
}
